import { render, staticRenderFns } from "./AdjustCreate.vue?vue&type=template&id=bbda0a74&"
import script from "./AdjustCreate.vue?vue&type=script&lang=js&"
export * from "./AdjustCreate.vue?vue&type=script&lang=js&"
import style0 from "./AdjustCreate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports